import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import * as _ from 'underscore';
import * as jQuery from 'jquery';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import * as M from 'mapbox-gl';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import {
	EVENT_EMITTERS,
	MAP_CONSTANTS,
	COUNTRY_MAP_COORDINATES,
	GAM_PRODUCT_SEPERATED_Rs
} from '../../../analytics/constants/analytics.constants';
import { MapComponentService, MapInterface, MapLegendItem } from './map.component.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';
import { PATHS } from '../../../analytics/constants/analytics.constants';
/**
 *  Map Component for Reporting Version 1
 */
@Component({
	selector: 'app-map',
	templateUrl: './map.component.html',
	styleUrls: ['./map.component.css'],
	providers: [MapComponentService]
})
export class MapComponent implements OnInit, AfterViewInit, WidgetCore, OnDestroy {
	/**
	 * Input's
	 */
	@Input() key: string;
	@Input() path: string;
	@Input() timeserieskey: string;
	@Input() markericon: string;
	@Input() heatmapenabled: any;
	@Input() liftdistributionenabled: any;
	@Input() liftareacolor: string;
	@Input() showgeofencepoints: any;
	@Input() showgeocenters: any;
	@Input() showthirdpartyrtg: any;
	@Input() sectiontitle: string;
	@Input() sectionclass: string;
	@Input() mapboxstyles: any;
	@Input() customaccesstoken: string;
	@Input() barchartconfiguration: any;
	@Input() showgeofenceonoverview: any;
	@Input() uniqueoverwriteid: string;
	@Input() getdatafromwidget: string;
	@Input() geofencegeovideocallattibutekey: any;
	public widgetIdProcesReq: string;
	public primaryColor: any;
	public isR8: boolean = false;
	selectedItems: { [key: string]: boolean } = {};
	public clearAllCalled = false;
	public doohData;

	protected accessToken =
		'pk.eyJ1IjoiZnJlcS1lLWRlZWsiLCJhIjoiY2lmcHpidnJ6aHlxeHI3bHhvbzFtZTI4ZCJ9.BqXwR2aAH83EuuX0-ozozA';
	protected mapStyle = 'mapbox://styles/freq-e-deek/cj9xxx4nr744q2so6owxaxkaf';
	protected miniMapStyle = 'mapbox://styles/mapbox/satellite-streets-v9';

	public showPolygonLayerDetailsFlag = false;
	public showGeofenceCenterDetailsFlag = false;
	public polygonLayerDetails: any = {};
	public geofenceCenterDetails: any;
	public noRegionData = false;

	public detailMapPoints: any;

	public showLoad = true;
	public histogramData = {};
	public showGeofenceLegends: boolean = false;
	protected detailsTimeInterval: any;
	protected mapFillColor = 'rgba(6, 70, 85,0.75)';
	protected mapFillOutlineColor = 'rgba(200, 200, 200, 0.8)';
	public noData = true;

	public circleMarkerStyles = {
		'circle-color': this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'primary',
			1
		),
		'circle-radius': 5,
		'circle-stroke-color': '#FFF',
		'circle-stroke-width': 1
	};
	public circleMarkerStylesInvisible = {
		// to hide the dots on polygons. As that layer code is long back one and it might impact other places if we remove.
		'circle-color': 'transparent',
		'circle-radius': 5,
		'circle-stroke-color': 'transparent',
		'circle-stroke-width': 1
	};
	protected geofenceBackgroundFillStyle = {
		'circle-color': this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'primary',
			1
		),
		'circle-radius': 5,
		'circle-stroke-color': '#FFF',
		'circle-stroke-width': 1
	};
	public map: any;
	public minimap: any;
	public partnerCountryAbbr =
		this.analyticsDataModel.setupData.partner.countryDetails[0]['country_abbreviation'].toUpperCase();
	public partnerCountryLngLat = COUNTRY_MAP_COORDINATES[this.partnerCountryAbbr ? this.partnerCountryAbbr : 'USA'];
	public defaultMapZoom = 3;
	public mapCoordinates = {
		lng: 0,
		lat: 0
	};

	protected sourceLayerDetails: any;
	protected mapType = 'overview';

	protected selectedCombination;
	protected displayGeoFenceData;
	protected displayGeoRecencyData;
	protected prerollGeoFenceData;
	protected prerollGeoRecencyData;
	protected heatmapOpacities = {};
	protected geoFenceMarkers = [];
	protected geoVideoMarkers = [];
	protected geoFenceRecencyLayersDrawn = false;
	protected DoohGeoFenceRecencyLayersDrawn = false;
	protected hasOnlyGeoFenceSelected: boolean = false;
	public mapObj: MapInterface;
	public legendItems: MapLegendItem[] = [];

	protected vectorMap: any = {};
	protected mapboxMapId: any = this.analyticsDataModel.setupData.partner.mapboxId;
	protected intervalFn: any;
	protected showingLiftRegionsOnMap = false;
	protected doohGeoRecencyData;
	public isDOOH: boolean = false;

	/**
	 *
	 * @type {{productName: string; productKey: string; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected DEFAULT_PRODUCTS = [
		{
			productName: 'Television',
			productKey: MAP_CONSTANTS.STATE.TELEVISION_MIDCO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasTelevision'],
			order: 1
		},
		{
			productName: 'Display',
			productKey: MAP_CONSTANTS.STATE.DISPLAY,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasDisplay'],
			order: 2
		},
		{
			productName: 'GAM',
			productKey: MAP_CONSTANTS.STATE.GAM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasGAM'],
			order: 2
		},
		{
			productName: 'Pre Roll',
			productKey: MAP_CONSTANTS.STATE.PREROLL,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasPreroll'],
			order: 3
		},
		{
			productName: 'SEM',
			productKey: MAP_CONSTANTS.STATE.SEM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasSem'],
			order: 4
		},
		{
			productName: 'Connected TV',
			productKey: MAP_CONSTANTS.STATE.CTV,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasCtv'],
			order: 5
		},
		{
			productName: 'Streaming Audio',
			productKey: MAP_CONSTANTS.STATE.RADIO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasRadio'],
			order: 6
		}
	];

	protected R8_DEFAULT_PRODUCTS = [
		{
			productName: 'Display',
			productKey: MAP_CONSTANTS.STATE.DISPLAY,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasDisplay'],
			order: 1
		},
		{
			productName: 'Pre Roll',
			productKey: MAP_CONSTANTS.STATE.PREROLL,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasPreroll'],
			order: 2
		},
		{
			productName: 'Connected TV',
			productKey: MAP_CONSTANTS.STATE.CTV,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasCtv'],
			order: 3
		},
		{
			productName: 'SEM',
			productKey: MAP_CONSTANTS.STATE.SEM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasSem'],
			order: 4
		},
		{
			productName: 'Streaming Audio',
			productKey: MAP_CONSTANTS.STATE.RADIO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasRadio'],
			order: 5
		},
		{
			productName: 'GAM',
			productKey: MAP_CONSTANTS.STATE.GAM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasGAM'],
			order: 6
		}
	];

	/**
	 *
	 * @type {{productName: string; productKey: string; showInLegend: boolean; show: boolean; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected GF_PRODUCTS = [
		{
			productName: 'Geofence',
			productKey: MAP_CONSTANTS.STATE.GEOFENCE,
			showInLegend: true,
			show: true,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasDisplay']
		},
		{
			productName: 'Georecency',
			productKey: 'georecency',
			showInLegend: false,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasDisplay']
		},
		{
			productName: 'Geovideo',
			productKey: MAP_CONSTANTS.STATE.GEOVIDEO,
			showInLegend: true,
			show: true,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasPreroll'],
			productRelated: 'Preroll'
		},
		{
			productName: 'GeorecencyPreroll',
			productKey: 'georecencyPreroll',
			showInLegend: false,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasPreroll'],
			productRelated: 'Preroll'
		},
		{
			productName: 'DOOH',
			productKey: 'dooh',
			showInLegend: false,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasDOOH']
		}
	];

	public reloadSubscription;
	public mapDataSubscription;
	public mapBoundsSubscription;
	public isR103: boolean = false;
	public isR104: boolean = false;
	public isR101: boolean = false;
	public isR1101: boolean = false;
	public isR6: boolean = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService,
		protected mapComponentService: MapComponentService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
			this.noRegionData = false;
		});
	}

	/**
	 * Lifecycle hook that is called after data-bound properties of a directive are
	 * initialized.
	 */
	ngOnInit() {
		this.isR8 = this.analyticsDataModel.config.version === 'R8' ? true : false;
		this.isDOOH = this.analyticsDataModel.getCurrentPath() === PATHS.DOOH;
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		this.isR103 =
			this.analyticsDataModel.config.partner.directoryName === 'default-r103' ||
			this.analyticsDataModel.config.partner.directoryName === 'entravision-r103'
				? true
				: false;
		this.isR6 = this.analyticsDataModel.config.version === 'R6' ? true : false;
		this.DEFAULT_PRODUCTS = this.isR8 ? this.R8_DEFAULT_PRODUCTS : this.DEFAULT_PRODUCTS;
		this.mapCoordinates['lng'] = this.partnerCountryLngLat['lng'] - 15;
		this.mapCoordinates['lat'] = this.partnerCountryLngLat['lat'];

		let tempPermissions = [];
		tempPermissions = this.analyticsDataModel.setupData.permissions;
		let gam_seperated = GAM_PRODUCT_SEPERATED_Rs.includes(this.analyticsDataModel.config.directoryName);
		if (!gam_seperated || (gam_seperated && !tempPermissions.includes('hasGamMapAccess'))) {
			this.DEFAULT_PRODUCTS = this.DEFAULT_PRODUCTS.filter((item) => item.productName !== 'GAM');
		}

		this.mapComponentService.defaultProducts = this.DEFAULT_PRODUCTS;
		this.mapComponentService.geofenceProducts = this.GF_PRODUCTS;
		this.mapStyle = this.mapboxstyles ? this.mapboxstyles : this.mapStyle;
		this.miniMapStyle = this.mapboxstyles ? this.mapboxstyles : this.miniMapStyle;
		this.accessToken =
			this.customaccesstoken && this.customaccesstoken !== '' ? this.customaccesstoken : this.accessToken;
		this.barchartconfiguration = this.barchartconfiguration ? JSON.parse(decodeURI(this.barchartconfiguration)) : [];
		this.primaryColor = this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'primary',
			1
		);
		if (this.isR104 || this.isR103) {
			this.circleMarkerStyles = {
				'circle-color': this.colorUtilityService.getHEXByColorType(
					this.analyticsDataModel.partner.colorPalette,
					'secondary',
					1
				),
				'circle-radius': 5,
				'circle-stroke-color': '#FFF',
				'circle-stroke-width': 1
			};
			if (this.isR104) {
				this.primaryColor = this.colorUtilityService.getHEXByColorType(
					this.analyticsDataModel.partner.colorPalette,
					'secondary',
					1
				);
			}
		}
		this.mapFillColor = this.colorUtilityService.getRGBByOpacity(this.primaryColor, 0.75);

		if (this.isR103) {
			let televisionSorted = false;
			this.DEFAULT_PRODUCTS.forEach((element, index) => {
				if (element.productName == 'Television') {
					if (!televisionSorted) {
						this.DEFAULT_PRODUCTS.push(this.DEFAULT_PRODUCTS.shift());
						element.productName = 'TV';
					}
					televisionSorted = true;
				}
				if (element.productName == 'Streaming Audio') {
					element.productName = 'Audio';
				}
			});
		}
		// commenting the below accessToken as we are using different mapboxStyles now and which needed default accessToken
		// this.accessToken = this.isR103
		// 	? 'pk.eyJ1IjoiYnJvb2tlbXlsYW5kZXIiLCJhIjoiY2xkMHFrcTJ6MDA3NjNyanpqcnlhMTdieSJ9.qEBFzj48gugejXz9to3HrA'
		// 	: this.accessToken;
	}

	/**
	 * Lifecycle hook that is called after a component's view has been fully
	 * initialized.
	 */
	ngAfterViewInit() {
		this.mapboxMapId.forEach((vectorId) => {
			this.vectorMap[vectorId] = {
				source_layers: {
					points: { properties: ['gcd_id', 'local_id'] },
					polygons: { properties: ['gcd_id', 'local_id'] }
				}
			};
		});
		Object.getOwnPropertyDescriptor(M, 'accessToken').set(this.accessToken);
		this.liftdistributionenabled = this.liftdistributionenabled === 'true';
		this.heatmapenabled = this.heatmapenabled === 'true';
		this.showgeocenters = this.showgeocenters === 'true' ? true : false;
		this.showthirdpartyrtg =
			this.showthirdpartyrtg == 'undefined' ? true : this.showthirdpartyrtg === 'true' ? true : false;
		this.showgeofencepoints = this.showgeofencepoints === 'true' ? true : false;
		this.showgeofenceonoverview = this.showgeofenceonoverview === 'true' ? true : false;
		// Getting backend data
		this.initializeMap();
		this.requestData();
	}

	/**
	 * Lifecycle hook that is called when a directive, pipe or service is destroyed.
	 */
	ngOnDestroy() {
		this.destroyMap();
		this.vectorMap = {};
		this.polygonLayerDetails = {};
		this.heatmapOpacities = {};
		this.geoFenceMarkers = [];
		this.geoVideoMarkers = [];
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.mapDataSubscription) {
			this.mapDataSubscription.unsubscribe();
		}
		if (this.mapBoundsSubscription) {
			this.mapBoundsSubscription.unsubscribe();
		}
	}

	/**
	 *
	 */
	protected initializeMap() {
		this.map = new M.Map({
			container: 'map', // container id
			style: this.mapStyle, // stylesheet location
			center: [this.mapCoordinates['lng'], this.mapCoordinates['lat']], // starting position [lng, lat]
			zoom: this.defaultMapZoom // starting zoom
		});
		this.map.scrollZoom.disable();
		this.map.on('load', () => {
			this.map.on('mousemove', 'geofence-markers', (e) => {
				this.showGeofenceCenterDetails(e.features[0].properties);
				this.showGeoVideoCenterDetails(e.features[0].properties);
			});

			this.map.on('mouseleave', 'geofence-markers', () => {
				this.hideGeofenceCenterDetails();
			});

			this.map.on('zoomend', () => {
				this.zoomChanged();
			});
		});
		this.minimap = new M.Map({
			container: 'minimap', // container id
			style: this.miniMapStyle, // stylesheet location
			center: [this.mapCoordinates['lng'], this.mapCoordinates['lat']], // starting position [lng, lat]
			zoom: 5 // starting zoom
		});
	}

	showGeoVideoCenterDetails(geofenceCenterPoint) {}

	/**
	 *
	 */
	protected destroyMap() {
		if (this.map) {
			this.map.remove();
		}
		if (this.minimap) {
			this.minimap.remove();
		}
	}

	/**
	 * get data from backend and process data
	 * @param product - selected state
	 */
	requestData() {
		this.showLoad = true;
		jQuery('.no-data-map-overlay').remove();
		jQuery('.impression-gradient').css('display', 'flex');
		this.noData = false;
		this.mapComponentService.showThirdPartyRTG = this.showthirdpartyrtg;
		this.mapComponentService.setSelectedStateByPath(this.path);
		const selectedState = this.mapComponentService.selectedState;
		//next line:  to get the overview map data to use if there is no changes in adv/camp/dates changes and overview page already loaded
		this.widgetIdProcesReq = !this.isDOOH
			? !this.widgetIdProcesReq && this.getdatafromwidget && this.getdatafromwidget != 'undefined'
				? !this.AnalyticsDataChachingService.checkSelectionsChanges(this.getdatafromwidget)
					? this.AnalyticsDataChachingService.ANALYTICS_WIDGETS_CACHED_DATA.data[this.getdatafromwidget]?.['response']
						? this.getdatafromwidget
						: this.uniqueoverwriteid
					: this.uniqueoverwriteid
				: this.uniqueoverwriteid
			: null;
		this.mapDataSubscription = this.analyticsService
			.getMapWidgetData(this.key, selectedState, null, this.widgetIdProcesReq, this.geofencegeovideocallattibutekey)
			.subscribe((res: any) => {
				if (res.success) {
					//next condition:  to get the overview map data to use if there is no changes in adv/camp/dates changes and overview page already loaded
					if (this.widgetIdProcesReq !== this.uniqueoverwriteid) {
						let reqData = {};
						if (!res.data[selectedState]) {
							res.data[selectedState] = {
								geofence_multipoints: '',
								hide_show_geofence_on_zoom_level: '0',
								zr_regions: []
							};
						}
						res.data[selectedState]['zr_regions'] = res.data['all']?.['zr_regions'];
						reqData[selectedState] = res.data[selectedState];
						res.data = reqData;
					}
					// Process backend data
					const productsCount = Object.keys(res.data).length;
					if (productsCount) {
						// showgeofenceonoverview - will enable/disable geofence/geovideo points on overview
						let processObj = { data: res.data, condition: this.showgeofenceonoverview };
						// Process backend data
						this.mapComponentService.mapData = processObj;
						this.mapObj = this.mapComponentService.generateMapRequiredData(
							this.analyticsDataModel.setupData.permissions
						);
						this.legendItems = this.mapObj.legend;
						this.displayGeoFenceData = this.mapComponentService.displayGeofenceObj;
						this.displayGeoRecencyData = this.mapComponentService.displayGeorecencyObj;
						this.doohData = this.mapComponentService.doohGeorecencyObj;
						this.doohGeoRecencyData = JSON.parse(JSON.stringify(this.doohData));

						// Object to track selected DOOH checkboxes (keyed by id)
						this.selectedItems = this.doohData.features.reduce((acc, feature) => {
							acc[feature.properties.id] = true; // All checkboxes are selected initially
							return acc;
						}, {});
						this.prerollGeoFenceData = this.mapComponentService.prerollGeofenceObj;
						this.prerollGeoRecencyData = this.mapComponentService.prerollGeorecencyObj;
						if (
							(this.displayGeoFenceData &&
								this.displayGeoFenceData.features &&
								this.displayGeoFenceData.features.length > 0) ||
							(this.prerollGeoFenceData &&
								this.prerollGeoFenceData.features &&
								this.prerollGeoFenceData.features.length > 0)
						) {
							this.showGeofenceLegends = true;
						} else {
							this.showGeofenceLegends = false;
						}
						this.checkIfOnlyGeoFenceProductsSelected(this.legendItems.filter((legend) => legend.isSelected));
						EmitterService.get(EVENT_EMITTERS.INITIATE_MAP_STATS).emit(this.mapObj);
						if (this.mapObj && this.mapObj.combinations.length > 0) {
							this.updateSelectedRegionsOnProductSelection();
							this.getBoundsForAllFilters();
							if (
								this.selectedCombination.key.includes('display') ||
								this.selectedCombination.key.includes('preroll')
							) {
								this.liftdistributionenabled = true;
							} else {
								this.liftdistributionenabled = false;
							}
							if (this.liftdistributionenabled && this.selectedCombination) {
								this.histogramData = this.mapComponentService.processRegionDataOnSelection(
									this.selectedCombination.regionData
								);
							}
							setTimeout(() => {
								const intervalFn = setInterval(() => {
									if (this.checkFilterObjStatus()) {
										clearInterval(intervalFn);
										this.drawMap();
									}
								}, 200);
							}, 50);
						} else if (
							(this.displayGeoFenceData.features.length > 0 ||
								this.prerollGeoFenceData.features.length > 0 ||
								this.displayGeoRecencyData.features.length > 0 ||
								this.prerollGeoRecencyData.features.length > 0 ||
								this.doohGeoRecencyData.features.length > 0) &&
							this.mapObj.combinations.length === 0
						) {
							this.selectedCombination = undefined;
							setTimeout(() => {
								this.drawMap();
								const mapBounds = this.boundsForAvailableGeoFenceProducts;
								let zoomRange = this.get_bounds_zoom(mapBounds);
								// setting zoomRange to 15 to avoid the map to take original zoom level that is more ex: 21
								// this occurs when a particular campaign is selected with the default zoom range
								// Note: If zoom level > 12 then Satellite view will be enabled
								zoomRange = zoomRange > 15 ? 15 : zoomRange;
								this.map.fitBounds(mapBounds, {
									// padding: { top: 100, bottom: 300, left: 400, right: 20 },
									linear: true,
									maxZoom: zoomRange
								});
							}, 500);
						} else {
							this.selectedCombination = undefined;
							this.mapObj = undefined;
							this.showGeofenceLegends = false;
							this.refreshMap();
							this.removeAllGeoFenceMarkers();
							this.removeAllGeoVideoMarkers();
							this.removeGeoFenceRecencyLayer();
							this.removeGeoVideoRecencyLayer();
							this.removeDOOHGeoRecencyLayer();
							this.drawCenter();

							this.showLoad = false;
							if (
								jQuery('.mapboxgl-canvas').children().length == 0 &&
								this.isR6 &&
								jQuery('.no-data-map-overlay').length <= 0
							) {
								jQuery('.mapboxgl-canvas').after('<div class="no-data-map-overlay">Map Data is Not Available</div>');
								jQuery('.impression-gradient').css('display', 'none');
							}
						}
						this.noData = false;
					} else {
						this.selectedCombination = undefined;
						this.mapObj = undefined;
						this.showGeofenceLegends = false;
						this.refreshMap();
						this.removeAllGeoFenceMarkers();
						this.removeAllGeoVideoMarkers();
						this.removeGeoFenceRecencyLayer();
						this.removeGeoVideoRecencyLayer();
						this.removeDOOHGeoRecencyLayer();
						this.drawCenter();
						this.showLoad = false;
						this.noData = true;
						if (
							jQuery('.mapboxgl-canvas').children().length == 0 &&
							this.isR6 &&
							jQuery('.no-data-map-overlay').length <= 0
						) {
							jQuery('.mapboxgl-canvas').after('<div class="no-data-map-overlay">Map Data is Not Available</div>');
							jQuery('.impression-gradient').css('display', 'none');
						}
						return;
					}
				} else {
					this.selectedCombination = undefined;
					this.mapObj = undefined;
					this.showGeofenceLegends = false;
					this.refreshMap();
					this.removeAllGeoFenceMarkers();
					this.removeAllGeoVideoMarkers();
					this.removeGeoFenceRecencyLayer();
					this.removeGeoVideoRecencyLayer();
					this.removeDOOHGeoRecencyLayer();
					this.drawCenter();
					this.showLoad = false;
					this.noData = true;
					if (
						jQuery('.mapboxgl-canvas').children().length == 0 &&
						this.isR6 &&
						jQuery('.no-data-map-overlay').length <= 0
					) {
						jQuery('.mapboxgl-canvas').after('<div class="no-data-map-overlay">Map Data is Not Available</div>');
						jQuery('.impression-gradient').css('display', 'none');
					}
				}
			});
	}

	removeGeoVideoRecencyLayer() {}

	removeAllGeoVideoMarkers() {
		for (const marker of this.geoVideoMarkers) {
			marker.remove();
		}
	}

	/**
	 * Returns zoom for a given set of Mapbox GL bounds if map is fit to those bounds
	 * TODO: Implement check for padding
	 *  @author Malaika Chandler
	 * @param {LatLngBounds} comparisonBounds, bounds to check
	 * @return {float} zoom
	 */
	protected get_bounds_zoom = function (comparisonBounds) {
		const current_bounds = this.map.getBounds();
		const current_zoom = this.map.getZoom();
		if (!_.isEmpty(comparisonBounds)) {
			const best_fit = Math.min(
				Math.log2(
					(current_bounds.getNorth() - current_bounds.getSouth()) /
						(comparisonBounds.getNorth() - comparisonBounds.getSouth())
				),
				Math.log2(
					(current_bounds.getEast() - current_bounds.getWest()) /
						(comparisonBounds.getEast() - comparisonBounds.getWest())
				)
			);
			return best_fit != Infinity ? best_fit + current_zoom - 0.8 : current_zoom - 0.5; // Until bounds with pitch/tilt can be calculated correctly
		}
		return current_zoom - 0.5;
	};

	/**
	 *
	 * @param filterObj
	 */
	protected getBoundsByZCTAIds(filterObj) {
		this.mapBoundsSubscription = this.analyticsService
			.getBoundsByZCTA(filterObj.localIds)
			.subscribe((response: any) => {
				if (!filterObj.status && response.success) {
					this.calculateZoomForFilterObj(filterObj, response.bounds);
				}
			});
	}

	/**
	 *
	 * @param filterObj
	 * @param boundValues
	 */
	protected calculateZoomForFilterObj(filterObj, boundValues) {
		const minLng = !UtilityService.isUndefinedOrNull(boundValues[0][0]) ? parseFloat(boundValues[0][0]) : 0;
		const minLat = !UtilityService.isUndefinedOrNull(boundValues[0][1]) ? parseFloat(boundValues[0][1]) : 0;
		const maxLat = !UtilityService.isUndefinedOrNull(boundValues[1][1]) ? parseFloat(boundValues[1][1]) : 0;
		const maxLng = !UtilityService.isUndefinedOrNull(boundValues[1][0]) ? parseFloat(boundValues[1][0]) : 0;
		const bounds: any = [
			[minLng, minLat],
			[maxLng, maxLat]
		];
		const comparisonBounds = M.LngLatBounds.convert(bounds);
		const zoomRange = this.get_bounds_zoom(comparisonBounds);
		filterObj.zoomRange = zoomRange;
		filterObj.center = comparisonBounds.getCenter();
		filterObj.status = !filterObj.stack;
	}

	protected getBoundsForAllFilters() {
		const combinations = this.mapObj.combinations;
		for (const combination of combinations) {
			this.getBoundsByZCTAIds(combination);
		}
	}

	/**
	 *
	 * @returns {boolean}
	 */
	protected checkFilterObjStatus() {
		const statusArray = _.pluck(this.mapObj.combinations, 'status');
		return _.indexOf(statusArray, false) === -1;
	}

	/**
	 *
	 */
	protected checkFiltersStatus() {
		if (this.checkFilterObjStatus()) {
			clearInterval(this.intervalFn);
			this.drawMap();
		}
	}

	/**
	 *
	 */
	protected drawMap() {
		this.processResponseData();
		if (!_.isEmpty(this.displayGeoFenceData) || !_.isEmpty(this.prerollGeoFenceData)) {
			this.drawGeoFencePoints();
			this.drawGeoRecencyLayer();
			this.drawDOOHGeoRecencyLayer();
		} else {
			this.removeAllGeoFenceMarkers();
			this.removeAllGeoVideoMarkers();
			this.removeGeoFenceRecencyLayer();
			this.removeGeoVideoRecencyLayer();
			this.removeDOOHGeoRecencyLayer();
		}
		this.showLoad = false;
	}

	/**
	 *
	 */
	protected updateSelectedRegionsOnProductSelection() {
		const nonDependentItems = _.where(this.legendItems, { isDependent: false });
		const selectedLegendItems = _.where(nonDependentItems, { isSelected: true });
		const productKeys = _.pluck(selectedLegendItems, 'productKey');
		const combinationKey = this.getCombinationKeyByProductKeys(productKeys);
		const combinationObj: any = _.findWhere(this.mapObj.combinations, { key: combinationKey });
		this.selectedCombination = combinationObj;
	}

	/**
	 *
	 * @param {string[]} productKeys
	 * @returns {string}
	 */
	protected getCombinationKeyByProductKeys(productKeys: string[]) {
		return productKeys.join('_');
	}

	/**
	 *
	 */
	processResponseData() {
		for (const vectorMapId in this.vectorMap) {
			this.removeMapLayer('overview_active_' + vectorMapId + '_points');
			this.removeMapLayer('overview_inactive_' + vectorMapId + '_points');
			this.removeMapLayer('overview_main_' + vectorMapId + '_polygons');
			this.removeMapLayer('overview_hover_' + vectorMapId + '_polygons');
			this.removeMapLayer('overview_lift_regions_' + vectorMapId + '_points');
			this.removeMapLayer('overview_lift_regions_hover' + vectorMapId + '_points');
			this.removeMapLayer('overview_lift_regions_' + vectorMapId + '_polygons');
			this.removeMapLayer('overview_lift_regions_hover' + vectorMapId + '_polygons');
			this.removeMapSource('overview_geography_source_' + vectorMapId);
			this.map.addSource('overview_geography_source_' + vectorMapId, {
				type: 'vector',
				url: 'mapbox://' + vectorMapId
			});

			this.sourceLayerDetails = this.vectorMap[vectorMapId].source_layers;
			this.drawLayersOnMap(vectorMapId);
		}
		this.drawCenter();
	}

	/**
	 *
	 */
	protected drawCenter() {
		if (this.selectedCombination && this.selectedCombination.center) {
			this.map.easeTo({
				center: this.selectedCombination.center,
				zoom: this.selectedCombination.zoomRange,
				duration: 0
			});
		} else if (this.hasOnlyGeoFenceSelected || this.doohGeoRecencyData?.features.length > 0) {
			const mapBounds = this.boundsForAvailableGeoFenceProducts;
			const zoomRange = this.get_bounds_zoom(mapBounds);
			if (!_.isEmpty(mapBounds)) {
				this.map.fitBounds(mapBounds, {
					linear: true,
					maxZoom: zoomRange
				});
			}
		} else {
			this.map.easeTo({
				center: [this.mapCoordinates['lng'], this.mapCoordinates['lat']], // starting position [lng, lat]
				zoom: this.defaultMapZoom, // starting zoom
				duration: 0
			});
		}
	}

	/**
	 *
	 * @param {string} vectorMapId
	 */
	protected drawLayersOnMap(vectorMapId: string) {
		for (const geoMapSourceLayer in this.sourceLayerDetails) {
			const filter = [];
			const geoFilter = [];
			const propertyToFilter = this.sourceLayerDetails[geoMapSourceLayer].properties[0];
			const geos = _.map(
				_.pluck(this.selectedCombination ? this.selectedCombination.regionData : [], propertyToFilter),
				(value) => {
					return parseInt(value);
				}
			);
			Array.prototype.push.apply(filter, ['in', propertyToFilter].concat(geos));
			geoFilter.push(filter);
			let layerOpacity = ['match', ['get', 'gcd_id'], 0, 1, 1];
			if (this.heatmapenabled && this.selectedCombination) {
				layerOpacity = this.selectedCombination.opacity;
			}
			this.drawRegionsLayer(geoMapSourceLayer, vectorMapId, geoFilter, propertyToFilter, layerOpacity);
			if (this.liftdistributionenabled && this.liftareacolor) {
				this.drawLiftLayer(geoMapSourceLayer, vectorMapId, geoFilter, propertyToFilter, layerOpacity);
			}
		}
	}

	/**
	 *
	 * @param {string} mapSourceLayer
	 * @param {string} vectorMapId
	 * @param filter
	 * @param propertyToFilter
	 * @param opacity
	 */
	protected drawRegionsLayer(
		mapSourceLayer: string,
		vectorMapId: string,
		filter: any,
		propertyToFilter: any,
		opacity?: any
	) {
		if (this.isDOOH) {
			return; // Exit the method early if isDOOH is false
		}
		if (mapSourceLayer === 'polygons') {
			this.removeMapLayer(this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer,
				type: 'fill',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'fill-color': this.mapFillColor,
					'fill-outline-color': this.mapFillOutlineColor,
					'fill-opacity': opacity
				},
				filter: filter[filter.length - 1]
			});

			this.removeMapLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer,
				type: 'fill',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'fill-color': this.mapFillColor,
					'fill-outline-color': this.mapFillOutlineColor,
					'fill-opacity': 1
				},
				filter: ['==', propertyToFilter, '']
			});

			let geo_hover_timeout;
			this.map.on('mousemove', this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const gcdId =
						e && e.features && e.features[0].properties['gcd_id'] ? e.features[0].properties['gcd_id'].toString() : '';
					let regionObject = gcdId ? _.findWhere(this.selectedCombination.regionData, { gcd_id: gcdId }) : {};
					this.displayLocationDataOnMouseover(regionObject, e);
				}
				clearTimeout(geo_hover_timeout);
				geo_hover_timeout = setTimeout(() => {
					if (this.map.getLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer)) {
						this.map.setFilter(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer, [
							'==',
							propertyToFilter,
							e && e.feature && e.feature[0] && e.features[0].properties
								? e.features[0].properties[propertyToFilter]
								: ''
						]);
					}
				}, 10);
			});

			this.map.on('mouseleave', this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer, () => {
				this.hideLocationDataOnMouseout();
				clearTimeout(geo_hover_timeout);
				geo_hover_timeout = setTimeout(() => {
					if (this.map.getLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer)) {
						this.map.setFilter(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer, [
							'==',
							propertyToFilter,
							''
						]);
					}
				}, 10);
			});
		} else if (mapSourceLayer === 'points') {
			this.removeMapLayer(this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer,
				type: 'circle',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: this.circleMarkerStylesInvisible,
				filter: filter[filter.length - 1]
			});
			this.map.setLayerZoomRange(this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, 1, 15);

			this.removeMapLayer(this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer,
				type: 'circle',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: this.circleMarkerStyles,
				filter: ['==', propertyToFilter, '']
			});
			this.map.setLayerZoomRange(this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer, 1, 15);

			this.map.on('mousemove', this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const regionObject = _.findWhere(this.selectedCombination.regionData, {
						gcd_id: e.features[0].properties['gcd_id'].toString()
					});
					this.displayLocationDataOnMouseover(regionObject, e);
				}
			});
			this.map.on('mousemove', this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const regionObject = _.findWhere(this.selectedCombination.regionData, {
						gcd_id: e.features[0].properties['gcd_id'].toString()
					});
					this.displayLocationDataOnMouseover(regionObject, e);
				}
			});
			this.map.on('mouseleave', this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				this.hideLocationDataOnMouseout();
			});
		}
	}

	/**
	 *
	 * @param {string} mapSourceLayer
	 * @param {string} vectorMapId
	 * @param filter
	 * @param propertyToFilter
	 * @param opacity
	 */
	protected drawLiftLayer(
		mapSourceLayer: string,
		vectorMapId: string,
		filter: any,
		propertyToFilter: any,
		opacity: any
	) {
		if (mapSourceLayer === 'polygons') {
			this.removeMapLayer(this.mapType + '_lift_regions_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_lift_regions_' + vectorMapId + '_' + mapSourceLayer,
				type: 'fill',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'fill-color': this.colorUtilityService.getRGBByOpacity(this.liftareacolor, 0.65),
					'fill-outline-color': this.colorUtilityService.getRGBByOpacity(this.liftareacolor, 1),
					'fill-opacity': 0
				},
				filter: filter[filter.length - 1]
			});

			this.removeMapLayer(this.mapType + '_lift_regions_hover' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_lift_regions_hover' + vectorMapId + '_' + mapSourceLayer,
				type: 'fill',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'fill-color': this.colorUtilityService.getRGBByOpacity(this.liftareacolor, 0.65),
					'fill-outline-color': this.colorUtilityService.getRGBByOpacity(this.liftareacolor, 1),
					'fill-opacity': 0
				},
				filter: filter[filter.length - 1]
			});
		} else if (mapSourceLayer === 'points') {
			this.removeMapLayer(this.mapType + '_lift_regions_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_lift_regions_' + vectorMapId + '_' + mapSourceLayer,
				type: 'circle',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				layout: {
					visibility: 'none'
				},
				paint: {
					'circle-color': this.liftareacolor,
					'circle-stroke-width': 1,
					'circle-stroke-color': '#FFFFFF'
				},
				filter: filter[filter.length - 1]
			});

			this.removeMapLayer(this.mapType + '_lift_regions_hover' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_lift_regions_hover' + vectorMapId + '_' + mapSourceLayer,
				type: 'circle',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				layout: {
					visibility: 'none'
				},
				paint: {
					'circle-color': this.liftareacolor,
					'circle-stroke-width': 1,
					'circle-stroke-color': '#FFFFFF'
				},
				filter: filter[filter.length - 1]
			});
		}
	}

	/**
	 *
	 * @param eventObj
	 */
	public showLiftRegions(eventObj) {
		const gcdId = eventObj.liftData.gcdId;
		const filter = ['in', 'gcd_id'];
		this.mapboxMapId.forEach((mapboxMapId) => {
			if (this.map.getLayer(this.mapType + '_lift_regions_' + mapboxMapId + '_' + 'polygons')) {
				Array.prototype.push.apply(filter, gcdId);
				this.showingLiftRegionsOnMap = true;
				this.map.setFilter(this.mapType + '_lift_regions_' + mapboxMapId + '_' + 'polygons', filter);
				this.map.setFilter(this.mapType + '_lift_regions_' + mapboxMapId + '_' + 'points', filter);
				this.map.setPaintProperty(this.mapType + '_lift_regions_' + mapboxMapId + '_' + 'polygons', 'fill-opacity', 1);
				this.map.setLayoutProperty(
					this.mapType + '_lift_regions_' + mapboxMapId + '_' + 'points',
					'visibility',
					'visible'
				);
			}
		});
	}

	/**
	 *
	 */
	public hideLiftRegions() {
		const filter = ['in', 'gcd_id'];
		const gcdId = [];
		this.mapboxMapId.forEach((mapboxMapId) => {
			if (this.map.getLayer(this.mapType + '_lift_regions_' + mapboxMapId + '_' + 'polygons')) {
				this.showingLiftRegionsOnMap = false;
				Array.prototype.push.apply(filter, gcdId);
				this.map.setFilter(this.mapType + '_lift_regions_' + mapboxMapId + '_' + 'polygons', filter);
				this.map.setFilter(this.mapType + '_lift_regions_' + mapboxMapId + '_' + 'points', filter);
				this.map.setPaintProperty(this.mapType + '_lift_regions_' + mapboxMapId + '_' + 'polygons', 'fill-opacity', 0);
				this.map.setLayoutProperty(
					this.mapType + '_lift_regions_' + mapboxMapId + '_' + 'points',
					'visibility',
					'none'
				);
			}
		});
	}

	/**
	 *
	 * @param eventObj
	 */
	protected showHoverLiftRegions(eventObj) {
		const gcdId = eventObj.liftData.gcdId;
		const filter = ['in', 'gcd_id'];
		this.mapboxMapId.forEach((mapboxMapId) => {
			if (this.map.getLayer(this.mapType + '_lift_regions_hover' + mapboxMapId + '_' + 'polygons')) {
				Array.prototype.push.apply(filter, gcdId);
				this.showingLiftRegionsOnMap = true;
				this.map.setFilter(this.mapType + '_lift_regions_hover' + mapboxMapId + '_' + 'polygons', filter);
				this.map.setFilter(this.mapType + '_lift_regions_hover' + mapboxMapId + '_' + 'points', filter);
				this.map.setPaintProperty(
					this.mapType + '_lift_regions_hover' + mapboxMapId + '_' + 'polygons',
					'fill-opacity',
					1
				);
				this.map.setLayoutProperty(
					this.mapType + '_lift_regions_hover' + mapboxMapId + '_' + 'points',
					'visibility',
					'visible'
				);
			}
		});
	}

	/**
	 *
	 */
	protected hideHoverLiftRegions() {
		const filter = ['in', 'gcd_id'];
		const gcdId = [];
		this.mapboxMapId.forEach((mapboxMapId) => {
			if (this.map.getLayer(this.mapType + '_lift_regions_hover' + mapboxMapId + '_' + 'polygons')) {
				this.showingLiftRegionsOnMap = false;
				Array.prototype.push.apply(filter, gcdId);
				this.map.setFilter(this.mapType + '_lift_regions_hover' + mapboxMapId + '_' + 'polygons', filter);
				this.map.setFilter(this.mapType + '_lift_regions_hover' + mapboxMapId + '_' + 'points', filter);
				this.map.setPaintProperty(
					this.mapType + '_lift_regions_hover' + mapboxMapId + '_' + 'polygons',
					'fill-opacity',
					0
				);
				this.map.setLayoutProperty(
					this.mapType + '_lift_regions_hover' + mapboxMapId + '_' + 'points',
					'visibility',
					'none'
				);
			}
		});
	}

	/**
	 *
	 * @param eventObj
	 */
	public toggleLiftRegions(eventObj) {
		const toggleStatus = eventObj.toggle;
		if (toggleStatus) {
			this.showHoverLiftRegions(eventObj);
		} else {
			this.hideHoverLiftRegions();
		}
	}

	protected showLift(regionObj) {
		let showLiftFlag = false;
		if (regionObj) {
			// const selectedLegendItems = this.legendItems.filter(legendItem => legendItem.isSelected);
			// const liftSupportedProducts = selectedLegendItems.filter(selectedLegendItem => selectedLegendItem.showLiftHover != undefined && selectedLegendItem.showLiftHover);
			// showLiftFlag = liftSupportedProducts.length > 0;
			const showLift = [];
			if (regionObj.television && parseInt(regionObj.television)) {
				const product = _.findWhere(this.DEFAULT_PRODUCTS, { productKey: MAP_CONSTANTS.STATE.TELEVISION_MIDCO });
				showLift.push(product.showLiftHover);
			}

			if (regionObj.sem && parseInt(regionObj.sem)) {
				const product = _.findWhere(this.DEFAULT_PRODUCTS, { productKey: MAP_CONSTANTS.STATE.SEM });
				showLift.push(product.showLiftHover);
			}

			if (regionObj.ctv && parseInt(regionObj.ctv)) {
				const product = _.findWhere(this.DEFAULT_PRODUCTS, { productKey: MAP_CONSTANTS.STATE.CTV });
				showLift.push(product.showLiftHover);
			}

			if (regionObj.display && parseInt(regionObj.display)) {
				const product = _.findWhere(this.DEFAULT_PRODUCTS, { productKey: MAP_CONSTANTS.STATE.DISPLAY });
				showLift.push(product.showLiftHover);
			}

			if (regionObj.preroll && parseInt(regionObj.preroll)) {
				const product = _.findWhere(this.DEFAULT_PRODUCTS, { productKey: MAP_CONSTANTS.STATE.PREROLL });
				showLift.push(product.showLiftHover);
			}

			const showLiftFlag = _.reduce(
				showLift,
				(val, bool) => {
					return val || bool;
				},
				false
			);

			return showLiftFlag;
		}
		return showLiftFlag;
	}

	/**
	 *
	 * @param regionObj
	 */
	protected displayLocationDataOnMouseover(regionObj, e) {
		if (!_.isEmpty(regionObj)) {
			this.polygonLayerDetails = {
				regionName: regionObj.city,
				region: regionObj.region,
				zip: regionObj.local_id,
				isTV: !!parseInt(regionObj.tv),
				isSem: !!parseInt(regionObj.sem),
				population: parseInt(regionObj.population).toLocaleString('en-US'),
				zone: regionObj.zone
			};

			this.polygonLayerDetails['showLift'] = this.showLift(regionObj);
			const nonDependentItems = _.where(this.legendItems, { isDependent: false });
			const selectedLegendItems = _.where(nonDependentItems, { isSelected: true });
			const productKeys = _.pluck(selectedLegendItems, 'productKey');
			const combinationKey = this.getCombinationKeyByProductKeys(productKeys);
			const combinationObj: any = _.findWhere(this.mapObj.combinations, { key: combinationKey });
			this.selectedCombination = combinationObj;
			if (regionObj.lift && this.polygonLayerDetails['showLift']) {
				if (combinationKey === 'ctv' || combinationKey === 'sem' || combinationKey === 'sem_ctv') {
					this.polygonLayerDetails['showLift'] = false;
				} else {
					this.polygonLayerDetails['avgLift'] =
						parseFloat(regionObj.lift.average_lift) > 0
							? parseFloat(regionObj.lift.average_lift) > 99
								? '> 99'
								: regionObj.lift.average_lift
							: '';
				}

				this.polygonLayerDetails['avgHomeValue'] = regionObj.lift.avg_home_value;
				this.polygonLayerDetails['percentageAvgHomeValue'] = this.prependPlusToPercentValue(
					regionObj.lift.percentage_avg_home_value
				);
				this.polygonLayerDetails['showAvgHomeStar'] = parseFloat(regionObj.lift.percentage_avg_home_value) > 0;
				this.polygonLayerDetails['avgMedianAge'] = regionObj.lift.avg_median_age;
				this.polygonLayerDetails['percentageAvgMedianAge'] = this.prependPlusToPercentValue(
					regionObj.lift.percentage_avg_median_age
				);
				this.polygonLayerDetails['showAvgMedianAgeStar'] = parseFloat(regionObj.lift.percentage_avg_median_age) > 0;
				this.polygonLayerDetails['avgIncome'] = regionObj.lift.avg_income;
				this.polygonLayerDetails['percentageAvgIncome'] = this.prependPlusToPercentValue(
					regionObj.lift.percentage_avg_income
				);
				this.polygonLayerDetails['showAvgIncomeStar'] = parseFloat(regionObj.lift.percentage_avg_income) > 0;
				this.polygonLayerDetails['avgOccupancy'] = regionObj.lift.avg_occupancy;
				this.polygonLayerDetails['percentageAvgOccupancy'] = this.prependPlusToPercentValue(
					regionObj.lift.percentage_avg_occupancy
				);
				this.polygonLayerDetails['showAvgOccupancyStar'] = parseFloat(regionObj.lift.percentage_avg_occupancy) > 0;
				this.polygonLayerDetails['averageBaseline'] =
					parseFloat(regionObj.lift.average_baseline) > 0 ? parseFloat(regionObj.lift.average_baseline).toFixed(2) : '';
				this.polygonLayerDetails['averageExposeRate'] =
					parseFloat(regionObj.lift.average_conversion_rate) > 0
						? parseFloat(regionObj.lift.average_conversion_rate).toFixed(2)
						: '';
			}

			this.showPolygonLayerDetailsFlag = true;
		}
	}

	/**
	 *
	 * @param {string} percentageValue
	 * @returns {any}
	 */
	protected prependPlusToPercentValue(percentageValue: string) {
		const percentageValueNumber = parseInt(percentageValue);
		if (percentageValueNumber > 0) {
			return '+' + percentageValueNumber;
		} else {
			return percentageValueNumber;
		}
	}

	/**
	 *
	 */
	protected hideLocationDataOnMouseout() {
		this.showPolygonLayerDetailsFlag = false;
		this.polygonLayerDetails = {};
	}

	/**
	 *
	 */
	protected drawGeoFencePoints(product?) {
		if (product) {
			if (product.productKey === MAP_CONSTANTS.STATE.GEOFENCE) {
				this.removeAllGeoFenceMarkers();
				this.geoFenceMarkers = [];
				this.displayGeoFenceData.features.forEach((marker) => {
					// create a DOM element for the marker
					const el = document.createElement('div');
					el.className = 'marker';
					el.style.backgroundImage = 'url(' + this.markericon + ')';
					el.style.backgroundPosition = 'center';
					el.style.backgroundSize = 'cover';
					el.style.width = 30 + 'px';
					el.style.height = 30 + 'px';
					el.addEventListener('mouseover', (event) => {
						this.showGeofenceCenterDetails(marker.properties);
					});

					el.addEventListener('mouseleave', (event) => {
						this.hideGeofenceCenterDetails();
						if (marker.properties.is_simplifi_restricted_geopoint) {
							jQuery('.geofence-disclaimer').css('display', 'block');
						}
					});

					// add marker to map
					const gfMarker = new M.Marker(el)
						.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
						.addTo(this.map);
					this.geoFenceMarkers.push(gfMarker);
				});
			} else if (product.productKey === MAP_CONSTANTS.STATE.GEOVIDEO) {
				this.removeAllGeoVideoMarkers();
				this.geoVideoMarkers = [];
				this.prerollGeoFenceData.features.forEach((marker) => {
					// create a DOM element for the marker
					const el = document.createElement('div');
					el.className = 'marker';
					el.style.backgroundImage = 'url(' + this.markericon + ')';
					el.style.backgroundPosition = 'center';
					el.style.backgroundSize = 'cover';
					el.style.width = 30 + 'px';
					el.style.height = 30 + 'px';
					el.addEventListener('mouseover', (event) => {
						this.showGeofenceCenterDetails(marker.properties);
					});

					el.addEventListener('mouseleave', (event) => {
						this.hideGeofenceCenterDetails();
						if (marker.properties.is_simplifi_restricted_geopoint) {
							jQuery('.geofence-disclaimer').css('display', 'block');
						}
					});

					// add marker to map
					const gfMarker = new M.Marker(el)
						.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
						.addTo(this.map);
					this.geoVideoMarkers.push(gfMarker);
				});
			}
		} else {
			this.removeAllGeoFenceMarkers();
			this.geoFenceMarkers = [];
			this.displayGeoFenceData.features.forEach((marker) => {
				// create a DOM element for the marker
				const el = document.createElement('div');
				el.className = 'marker';
				el.style.backgroundImage = 'url(' + this.markericon + ')';
				el.style.backgroundPosition = 'center';
				el.style.backgroundSize = 'cover';
				el.style.width = 30 + 'px';
				el.style.height = 30 + 'px';
				el.addEventListener('mouseover', (event) => {
					this.showGeofenceCenterDetails(marker.properties);
				});

				el.addEventListener('mouseleave', (event) => {
					this.hideGeofenceCenterDetails();
					if (marker.properties.is_simplifi_restricted_geopoint) {
						jQuery('.geofence-disclaimer').css('display', 'block');
					}
				});

				// add marker to map
				const gfMarker = new M.Marker(el)
					.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
					.addTo(this.map);
				this.geoFenceMarkers.push(gfMarker);
			});
			this.removeAllGeoVideoMarkers();
			this.geoVideoMarkers = [];
			this.prerollGeoFenceData.features.forEach((marker) => {
				// create a DOM element for the marker
				const el = document.createElement('div');
				el.className = 'marker';
				el.style.backgroundImage = 'url(' + this.markericon + ')';
				el.style.backgroundPosition = 'center';
				el.style.backgroundSize = 'cover';
				el.style.width = 30 + 'px';
				el.style.height = 30 + 'px';
				el.addEventListener('mouseover', (event) => {
					this.showGeofenceCenterDetails(marker.properties);
				});

				el.addEventListener('mouseleave', (event) => {
					this.hideGeofenceCenterDetails();
					if (marker.properties.is_simplifi_restricted_geopoint) {
						jQuery('.geofence-disclaimer').css('display', 'block');
					}
				});

				// add marker to map
				const gfMarker = new M.Marker(el)
					.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
					.addTo(this.map);
				this.geoVideoMarkers.push(gfMarker);
			});
		}
	}

	/**
	 *
	 */
	protected drawGeoRecencyLayer(product?) {
		this.geoFenceRecencyLayersDrawn = true;
		if (!product || (product && product.productKey == MAP_CONSTANTS.STATE.GEOFENCE)) {
			this.removeMapLayer('geofence_points_georecency');
			this.removeMapSource('geofence_points_georecency');
			if (this.map && !this.map.getLayer('geofence_points_georecency')) {
				if (this.displayGeoRecencyData.features.length > 0) {
					this.map.addLayer({
						id: 'geofence_points_georecency',
						type: 'circle',
						source: {
							type: 'geojson',
							data: this.displayGeoRecencyData
						},
						paint: this.circleMarkerStyles
					});
				}
			}
		}
		if (!product || (product && product.productKey == MAP_CONSTANTS.STATE.GEOVIDEO)) {
			this.removeMapLayer('geovideo_points_georecency');
			this.removeMapSource('geovideo_points_georecency');

			if (this.map && !this.map.getLayer('geovideo_points_georecency')) {
				if (this.prerollGeoRecencyData.features.length > 0) {
					this.map.addLayer({
						id: 'geovideo_points_georecency',
						type: 'circle',
						source: {
							type: 'geojson',
							data: this.prerollGeoRecencyData
						},
						paint: this.circleMarkerStyles
					});
				}
			}
		}
	}
	/**
	 *
	 */
	protected drawDOOHGeoRecencyLayer() {
		this.DoohGeoFenceRecencyLayersDrawn = true;
		this.removeMapLayer('dooh_geofence_points_georecency');
		this.removeMapSource('dooh_geofence_points_georecency');

		if (this.map && !this.map.getLayer('dooh_geofence_points_georecency')) {
			if (this.doohGeoRecencyData.features.length > 0) {
				this.map.addLayer({
					id: 'dooh_geofence_points_georecency',
					type: 'circle',
					source: {
						type: 'geojson',
						data: this.doohGeoRecencyData
					},
					paint: {
						'circle-color': ['get', 'venue_color'],
						'circle-radius': 5,
						'circle-stroke-color': '#FFF',
						'circle-stroke-width': 1
					}
				});

				const popup = new M.Popup({
					closeButton: false,
					closeOnClick: false
				});

				this.map.on('mouseenter', 'dooh_geofence_points_georecency', (e) => {
					this.map.getCanvas().style.cursor = 'pointer';

					// Loop through each feature
					for (let feature of this.doohGeoRecencyData.features) {
						if (feature.geometry.type === 'MultiPoint') {
							const coordinates = feature.geometry.coordinates;

							for (let i = 0; i < coordinates.length; i++) {
								const coordinate = coordinates[i];

								const pixelCoordinate = this.map.project(coordinate);
								const mousePixelPosition = e.point;

								const distance = Math.sqrt(
									Math.pow(pixelCoordinate.x - mousePixelPosition.x, 2) +
										Math.pow(pixelCoordinate.y - mousePixelPosition.y, 2)
								);

								const threshold = 10;
								if (distance <= threshold) {
									const venue_type = e.features[0].properties.venue_type_1;
									const feature_data = this.doohGeoRecencyData.features.filter(
										(f) => f.properties.venue_type_1 === venue_type
									)[0];
									const tooltipData = feature_data.geometry.points_data[i];

									if (tooltipData) {
										const venue_name = tooltipData.venue_name ? tooltipData.venue_name : '';
										const level2 = tooltipData.venue_type_2 ? tooltipData.venue_type_2 : '';
										const impressions = tooltipData.impression
											? Number(tooltipData.impression).toLocaleString('en-US')
											: 'N/A';

										const description = `
										  <div class="dooh-tooltip-content">
											<div class="dooh-tooltip-level1">${venue_name}</div>
											<div class="dooh-tooltip-level2">${venue_type} | ${level2}</div>
											<div class="dooh-tooltip-impressions">Impressions: ${impressions}</div>
										  </div>
										`;
										popup.setLngLat(coordinate).setHTML(description).addTo(this.map);
									}
									break;
								}
							}
						}
					}
				});

				this.map.on('mouseleave', 'dooh_geofence_points_georecency', () => {
					this.map.getCanvas().style.cursor = '';
					popup.remove();
				});
			}
		}
	}

	onCheckboxChange(event, feature) {
		if (event.target.checked) {
			this.doohGeoRecencyData.features.push(feature);
		} else {
			const index = this.doohGeoRecencyData.features.findIndex((f) => f.properties.id === feature.properties.id);
			if (index > -1) {
				this.doohGeoRecencyData.features.splice(index, 1);
			}
		}
		this.drawDOOHGeoRecencyLayer();
		this.drawCenter();
	}

	selectAll() {
		this.doohGeoRecencyData.features = [...this.doohData.features];
		this.selectedItems = this.doohData.features.reduce((acc, feature) => {
			acc[feature.properties.id] = true;
			return acc;
		}, {});

		this.drawDOOHGeoRecencyLayer();
		this.drawCenter();
	}

	clearAll() {
		this.doohGeoRecencyData.features = [];
		this.selectedItems = {};
		this.removeDOOHGeoRecencyLayer();
		this.drawCenter();
	}
	trackByRegionId(index: number, feature: any): string {
		return feature.properties.id;
	}

	protected removeGeoFenceRecencyLayer(product?) {
		if (this.geoFenceRecencyLayersDrawn) {
			if (product) {
				product.productKey === MAP_CONSTANTS.STATE.GEOFENCE
					? this.removeMapLayer('geofence_points_georecency')
					: this.removeMapLayer('geovideo_points_georecency');
			} else {
				this.removeMapLayer('geofence_points_georecency');
				this.removeMapLayer('geovideo_points_georecency');
			}
		}
	}
	protected removeDOOHGeoRecencyLayer() {
		if (this.DoohGeoFenceRecencyLayersDrawn) {
			this.removeMapLayer('dooh_geofence_points_georecency');
		}
	}

	/**
	 *
	 * @param id
	 */
	protected removeMapLayer(id) {
		if (this.map && typeof this.map.getLayer === 'function' && this.map.getLayer(id)) {
			this.map.removeLayer(id);
		}
	}

	/**
	 *
	 * @param id
	 */
	protected removeMapSource(id) {
		if (this.map && typeof this.map.getSource === 'function' && this.map.getSource(id)) {
			this.map.removeSource(id);
		}
	}

	/**
	 *
	 */
	protected removeAllGeoFenceMarkers() {
		this.removeGeoFenceMarker();
	}

	/**
	 *
	 */
	protected removeGeoFenceMarker() {
		for (const marker of this.geoFenceMarkers) {
			marker.remove();
		}
	}

	/**
	 * manage polygon center layer and polygon layer based on zoom level
	 */
	protected zoomChanged() {
		if (this.map.getZoom() > 6) {
			if (this.map && this.map.getLayer('polygons')) {
				this.map.setLayoutProperty('polygons', 'visibility', 'visible');
			}
			if (this.map && this.map.getLayer('polygon-centers')) {
				this.map.setLayoutProperty('polygon-centers', 'visibility', 'none');
			}
		} else {
			if (this.map && this.map.getLayer('polygon-centers')) {
				this.map.setLayoutProperty('polygon-centers', 'visibility', 'visible');
			}
			if (this.map && this.map.getLayer('polygons')) {
				this.map.setLayoutProperty('polygons', 'visibility', 'none');
			}
		}
	}

	/**
	 * toggle geofence and manage geofence layer
	 * @param flag - toggle value of geofence
	 */
	protected toggleGeoFenceData(flag, product?) {
		if (!flag) {
			if (product) {
				if (product.productKey === MAP_CONSTANTS.STATE.GEOFENCE) {
					this.removeAllGeoFenceMarkers();
					this.removeGeoFenceRecencyLayer(product);
				} else if (product.productKey === MAP_CONSTANTS.STATE.GEOVIDEO) {
					this.removeAllGeoVideoMarkers();
					this.removeGeoFenceRecencyLayer(product);
				}
			} else {
				this.removeAllGeoFenceMarkers();
				this.removeGeoFenceRecencyLayer();
				this.removeAllGeoVideoMarkers();
				this.removeGeoVideoRecencyLayer();
				this.removeDOOHGeoRecencyLayer();
			}
		} else {
			this.drawGeoFencePoints(product);
			this.drawGeoRecencyLayer();
			this.drawDOOHGeoRecencyLayer();
		}
	}

	/**
	 * Set map zoom level and lat, lon values based on layer data
	 */
	protected setMapBounds(map, boundsData, isApplyPadding) {
		let coordinates = [];
		map.resize();
		if (boundsData.features) {
			_.each(boundsData.features, (point: any) => {
				coordinates.push(point.geometry.coordinates);
			});
		} else {
			coordinates = boundsData.geometry.coordinates;
		}
		const boundedData = coordinates.reduce(function (bounds, coord) {
			return bounds.extend(coord);
		}, new M.LngLatBounds(coordinates[0], coordinates[0]));
		if (isApplyPadding) {
			map.fitBounds(boundedData, {
				padding: {
					top: 100,
					bottom: 10,
					left: 200,
					right: 10
				}
			});
		} else {
			if (coordinates.length > 1) {
				map.fitBounds(boundedData, {
					padding: 10
				});
			} else {
				map.fitBounds([coordinates[0], coordinates[0]], {
					zoom: 14
				});
			}
		}
	}

	/**
	 * map zoom in function
	 */
	public zoomIn() {
		this.map.setZoom(this.map.getZoom() + 1);
	}

	/**
	 * map zoom out function
	 */
	public zoomOut() {
		if (this.selectedCombination && this.selectedCombination.zoomRange) {
			this.selectedCombination.zoomRange = this.map.getZoom() - 1;
		}
		this.map.setZoom(this.map.getZoom() - 1);
	}

	/**
	 * Show geofence center data on hover
	 * @param geofenceCenterPoint - geofence center object
	 */
	protected showGeofenceCenterDetails(geofenceCenterPoint) {
		clearTimeout(this.detailsTimeInterval);
		this.showPolygonLayerDetailsFlag = false;
		this.showGeofenceCenterDetailsFlag = true;
		jQuery('.map-details-container').css('display', 'block');
		if (geofenceCenterPoint.is_simplifi_restricted_geopoint) {
			jQuery('.geofence-disclaimer').css('display', 'block');
		}
		this.geofenceCenterDetails = geofenceCenterPoint;
		this.geofenceCenterDetails.total_android = Math.round(
			(geofenceCenterPoint.android_impression_sum / geofenceCenterPoint.total_impression_sum) * 100
		);
		this.geofenceCenterDetails.total_ios = Math.round(
			(geofenceCenterPoint.ios_impression_sum / geofenceCenterPoint.total_impression_sum) * 100
		);
		let isRetargetingPoint = false;
		for (const geofenceFeatureObj of this.displayGeoFenceData.features) {
			if (geofenceFeatureObj.properties.region_id === geofenceCenterPoint.region_id) {
				isRetargetingPoint = geofenceFeatureObj.properties.is_rtg_center == 1;
				this.detailMapPoints = geofenceFeatureObj;
				break;
			}
		}
		for (const geofenceFeatureObj of this.prerollGeoFenceData.features) {
			if (geofenceFeatureObj.properties.region_id === geofenceCenterPoint.region_id) {
				isRetargetingPoint = geofenceFeatureObj.properties.is_rtg_center == 1;
				this.detailMapPoints = geofenceFeatureObj;
				break;
			}
		}

		if (this.minimap) {
			if (this.minimap.getSource('minimap-data')) {
				if (
					Object.keys(this.detailMapPoints.geometry).length === 0 &&
					this.detailMapPoints.geometry.constructor === Object
				) {
					this.detailMapPoints.geometry = {
						type: 'MultiPoint',
						coordinates: []
					};
				}
				this.minimap.getSource('minimap-data').setData(this.detailMapPoints);
			} else {
				this.minimap.addSource('minimap-data', {
					type: 'geojson',
					data: this.detailMapPoints
				});
				if (this.geofenceBackgroundFillStyle) {
					this.minimap.addLayer({
						id: 'minimap-points-2',
						type: 'circle',
						source: 'minimap-data',
						paint: this.geofenceBackgroundFillStyle
					});
				}
				this.minimap.addLayer({
					id: 'minimap-points',
					type: 'circle',
					source: 'minimap-data',
					paint: this.circleMarkerStyles
				});
			}
			if (isRetargetingPoint && this.minimap.getLayer('minimap-points')) {
				this.minimap.setLayoutProperty('minimap-points', 'visibility', 'none');
				if (this.geofenceBackgroundFillStyle && this.minimap.getLayer('minimap-points-2')) {
					this.minimap.setLayoutProperty('minimap-points-2', 'visibility', 'none');
				}
			} else {
				this.minimap.setLayoutProperty('minimap-points', 'visibility', 'visible');
				if (this.geofenceBackgroundFillStyle) {
					this.minimap.setLayoutProperty('minimap-points-2', 'visibility', 'visible');
				}
			}
			this.setMapBounds(this.minimap, this.detailMapPoints, false);
		}
	}

	/**
	 * Hide geofence center data on hover out
	 */
	protected hideGeofenceCenterDetails() {
		this.detailsTimeInterval = setTimeout(() => {
			this.showGeofenceCenterDetailsFlag = false;
			jQuery('.map-details-container').css('display', 'none');
			jQuery('.geofence-disclaimer').css('display', 'none');
		});
	}

	/**
	 * Change map layers based on selected legend item
	 * @param {MapLegendItem} legendItem
	 */
	public selectedProductDetails(legendItem: MapLegendItem) {
		legendItem.isSelected = !legendItem.isSelected;
		this.processLegendSelection();
		if (!legendItem.isDependent) {
			this.updateSelectedRegionsOnProductSelection();
			this.refreshMap();
		}
		this.drawCenter();
	}

	protected refreshMap() {
		const filter = ['in', 'gcd_id'];
		const regions =
			this.selectedCombination && this.selectedCombination.regions ? this.selectedCombination.regions : [];
		this.noRegionData = regions.length > 0 ? false : true;
		this.mapboxMapId.forEach((mapboxMapId) => {
			if (this.map && this.map.getLayer(this.mapType + '_main_' + mapboxMapId + '_' + 'polygons')) {
				Array.prototype.push.apply(filter, regions);
				this.map.setFilter(this.mapType + '_main_' + mapboxMapId + '_' + 'polygons', filter);
				if (this.map.getLayer(this.mapType + '_active_' + mapboxMapId + '_' + 'points')) {
					this.map.setFilter(this.mapType + '_active_' + mapboxMapId + '_' + 'points', filter);
				}

				if (
					this.selectedCombination &&
					!this.selectedCombination.key.includes('display') &&
					!this.selectedCombination.key.includes('preroll')
				) {
					this.liftdistributionenabled = false;
				} else {
					this.liftdistributionenabled = true;
				}

				if (this.liftdistributionenabled) {
					this.histogramData = this.mapComponentService.processRegionDataOnSelection(
						this.selectedCombination ? this.selectedCombination.regionData : {}
					);
				}
			}
		});
		// this.checkIfOnlyGeoFenceProductsSelected('');
	}

	protected processLegendSelection() {
		const nonDependentLegendItems = _.where(this.legendItems, { isDependent: false });
		if (this.analyticsDataModel.getCurrentPath() == 'overview') {
			for (let i = 0; i < 2; i++) {
				const gfProduct =
					i == 0
						? _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOFENCE })
						: _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOVIDEO });
				const selectedLegendItems = _.where(nonDependentLegendItems, { isSelected: true });
				if (selectedLegendItems.length === 0) {
					this.hasOnlyGeoFenceSelected = gfProduct ? gfProduct.isSelected : false;
					if (this.hasOnlyGeoFenceSelected) {
						this.noRegionData = false;
					} else {
						this.noRegionData = true;
					}
				}
				if (gfProduct) {
					this.toggleGeoFenceData(gfProduct.isSelected, gfProduct);
				}

				this.checkIfOnlyGeoFenceProductsSelected(selectedLegendItems);
			}
		} else {
			let gfProduct: any = {};
			if (this.analyticsDataModel.getCurrentPath() == 'display') {
				gfProduct = _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOFENCE });
			} else if (this.analyticsDataModel.getCurrentPath() == 'preroll') {
				gfProduct = _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOVIDEO });
			}
			const selectedLegendItems = _.where(nonDependentLegendItems, { isSelected: true });
			if (selectedLegendItems.length === 0) {
				this.hasOnlyGeoFenceSelected = gfProduct ? gfProduct.isSelected : false;
				if (this.hasOnlyGeoFenceSelected) {
					this.noRegionData = false;
				} else {
					this.noRegionData = true;
				}
			}
			if (gfProduct) {
				this.toggleGeoFenceData(gfProduct.isSelected);
			}

			this.checkIfOnlyGeoFenceProductsSelected(selectedLegendItems);
		}
	}

	get boundsForAvailableGeoFenceProducts() {
		const features = _.union(
			this.displayGeoFenceData.features,
			this.displayGeoRecencyData.features,
			this.doohGeoRecencyData.features,
			this.prerollGeoFenceData.features,
			this.prerollGeoRecencyData.features
		);
		const coordinates = this.getCoordinatesFromFeatures(features);
		const mapBounds = this.getBoundsByCoordinates(coordinates);
		return mapBounds;
	}

	protected getCoordinatesFromFeatures(features) {
		let coordinates = [];
		for (const feature of features) {
			coordinates = coordinates.concat(feature.geometry.coordinates);
		}
		return coordinates;
	}

	protected getBoundsByCoordinates(coordinates) {
		const mapBounds = coordinates.reduce(function (bounds, coord) {
			return bounds.extend(coord);
		}, new M.LngLatBounds(coordinates[0], coordinates[0]));
		return mapBounds;
	}

	onResize(event) {
		setTimeout(() => {
			if (this.map) {
				this.map.resize();
			}
		});
	}

	checkIfOnlyGeoFenceProductsSelected(selectedProducts) {
		const nonDependentItems = _.where(this.legendItems, { isDependent: false });
		const selectedLegendItems = _.where(nonDependentItems, { isSelected: true });
		const productNames = _.pluck(selectedLegendItems, 'productKey');
		this.showGeofenceLegends =
			productNames.includes(MAP_CONSTANTS.STATE.DISPLAY) || productNames.includes(MAP_CONSTANTS.STATE.PREROLL);
	}
}
